import { Pagination } from '../../../shared/models/app.model';
import { OPD, VitalSignDoc } from '../../queue/models/check-opd.model';

export interface InvoiceList extends Pagination {
  content: Invoice[];
}

export interface Invoice {
  docNo: string;
  invoiceNo: string;
  receiptNo: string;
  customerName: string;
  total: number;
  created: number;
  updated: number;
  status: InvoiceStatus;
  hasProgram: boolean;
}

export interface ReceiptList extends Pagination {
  content: Receipt[];
}

export interface Receipt {
  invoiceNo: string;
  receiptNo: string;
  customerName: string;
  total: number;
  created: number;
  updated: number;
}

export interface ContentDetail extends OPD {
  invoiceNo: string;
  receiptNo: string;
  status: any;
  all: number;
  total: number;
  discount: number;
  vitalSigns: VitalSignDoc[];
  hasProgram: boolean;
}

export enum InvoiceStatus {
  OVERDUE = 'OVERDUE',
  COMPLETE = 'COMPLETE',
  CANCEL = 'CANCEL'
}

export const InvoiceOptions = [
  {
    key: InvoiceStatus.OVERDUE,
    value: InvoiceStatus.OVERDUE
  },
  {
    key: InvoiceStatus.COMPLETE,
    value: InvoiceStatus.COMPLETE
  },
  {
    key: InvoiceStatus.CANCEL,
    value: InvoiceStatus.CANCEL
  }
];

export enum PaymentMethod {
  SCAN_QR = 'SCAN_QR',
  PETTY_CASH = 'PETTY_CASH'
}
